import { useAppSelector } from "hooks";
import { useMediaQuery } from "@mui/material";
import { selectWebStoreState } from "redux/slices";
import { RebateConfig } from "contexts/WebStoreProvider/types";

export const useRebateInfoPanelLogic = (rebateConfig: RebateConfig) => {
	const { rewardTypes } = useAppSelector(selectWebStoreState).store;
	const isPortrait = useMediaQuery("(max-width:649px)");

	const rewardType = rewardTypes?.find(
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
		(type: any) => type.id === rebateConfig?.inventoryType
	);

	return {
		rewardType,
		isPortrait
	};
};
